import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { getShape, getParticularPage, getNext, getPrevious, createShape, updateShape, handleSearch } from "./thunk";

const initialState = {
  shapes: [],
  edit: false,
  shape: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingShape: false,
  loadingNext: false,
  showCreateModal: false,
  // Form persistence state
  formData: {
    name: "",
    isActive: true,
  },
  activeShapeId: null,
};

export const shapeSlice = createSlice({
  name: "shape",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    shapeEditSuccess: (state, action) => {
      state.edit = true;
      state.shape = state.shapes.find((shape) => shape.id === action.payload);
      state.formData = state.shapes.find((shape) => shape.id === action.payload);
      state.activeShapeId = action.payload;
    },
    resetShapeForm: (state, action) => {
      if (action.payload) {
        state.formData = state.shape;
      } else {
        state.formData = initialState.formData;
        state.activeShapeId = null;
      }
    },
    saveShapeForm: (state, action) => {
      state.formData = action.payload;
    },
    clearAllShape: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingShape = false;
      state.shape = null;
      state.formData = initialState.formData;
      state.activeShapeId = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createShape.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createShape.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createShape.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateShape.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateShape.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateShape.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(getShape.pending, getParticularPage.pending, getPrevious.pending, getNext.pending, handleSearch.pending),
      (state) => {
        state.loadingShape = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getShape.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingShape = false;
        state.shapes = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getShape.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingShape = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, shapeEditSuccess, saveShapeForm, resetShapeForm, clearAllShape } =
  shapeSlice.actions;

export default shapeSlice.reducer;
